export default "__VITE_ASSET__CkBwC_L5__"